import { fetchProviderOAuthConnectionUrl } from './fetchProviderOAuthConnectionUrl';
import { handleConnectionStatusUpdate } from './handleConnectionStatusUpdate';
import { getOAuthErrorMessage } from './getOAuthErrorMessage';
import { PaymentProviderId } from '@wix/wix-payments-common';
export const oauthConnect = async _ref => {
  let {
    paymentProvider,
    paymentMethodTypesIds,
    credentials,
    context
  } = _ref;
  const {
    httpClient,
    send,
    emitSideEffect
  } = context;
  const fetchProviderOAuthConnectionUrlRequestParams = {
    methodIds: paymentMethodTypesIds,
    providerId: paymentProvider.id,
    credentials,
    httpClient: httpClient
  };
  const {
    redirectUri
  } = await fetchProviderOAuthConnectionUrl(fetchProviderOAuthConnectionUrlRequestParams);
  const formattedUrl = redirectUri.replace('{{emailPlaceholder}}', credentials.email);
  const oAuthWindow = window.open(formattedUrl, '_blank');
  let windowCheckIntervalId;
  try {
    if (paymentProvider.id !== PaymentProviderId.PayPal) {
      await Promise.race([handleConnectionStatusUpdate(), new Promise((_, reject) => {
        windowCheckIntervalId = window.setInterval(() => {
          if (oAuthWindow != null && oAuthWindow.closed) {
            reject(new Error(`${paymentProvider.title} window was closed`));
          }
        }, 500);
      })]);
    }
    void send(`${paymentProvider.title} was connected`);
    emitSideEffect('WIX_PAYMENTS_PAYMENT_PROVIDER_CONNECTED', {
      paymentProviderId: paymentProvider.id,
      paymentMethodTypesIds
    });
  } catch (e) {
    void send(getOAuthErrorMessage(e));
  } finally {
    window.clearInterval(windowCheckIntervalId);
  }
};
//# sourceMappingURL=oauthConnect.js.map